import { gql } from 'graphql-tag'

export const GET_ORGANIZATION = gql`
  query getOrganization($tid: String!) {
    organization(tid: $tid) {
      id
    }
  }
`
